import * as cleaningSupportCodes from '../../consts/iot/cleaningSupportCodes';
import iotDeviceConfig from './iotDeviceConfig';

const isAemFlexBatteryEnabled = () => getFeaturesConfig().aem_flex_battery;

const isAemPauseModeEnabled = () => getFeaturesConfig().aem_pause_mode;

const isDeviceResetEnabled = () => getFeaturesConfig().device_reset;

const isHolderLedModeEnabled = () => getFeaturesConfig().holder_led_intensity_mode;

const isDeviceLedModeEnabled = () => getFeaturesConfig().device_led_intensity_mode;

const isLedModeEnabled = () => isHolderLedModeEnabled() || isDeviceLedModeEnabled();

const isExtendedHolderLedModeEnabled = () => getFeaturesConfig().extended_holder_led_intensity_mode;

const isExtendedDeviceLedModeEnabled = () => getFeaturesConfig().extended_device_led_intensity_mode;

const isExtendedLedModeEnabled = () => isExtendedHolderLedModeEnabled() || isExtendedDeviceLedModeEnabled();

const isCleaningEnabled = () => !!getFeaturesConfig().device_self_cleaning;

const isChargingWhileCleaningNeeded = () => {
    return getFeaturesConfig().device_self_cleaning === cleaningSupportCodes.AVAILABLE_WHILE_CHARGING;
};

const isVibrationEnabled = () => {
    const _isHolderChargedVibrationEnabled = isHolderChargedVibrationEnabled();
    const _isExtendedHapticProfileVibrationEnabled = isExtendedHapticProfileVibrationEnabled();
    const _isProgrammableVibrationSettingsEnabled = isProgrammableVibrationSettingsEnabled();
    const _isStartVibrationEnabled = isStartVibrationEnabled();

    return (
        _isHolderChargedVibrationEnabled ||
        _isExtendedHapticProfileVibrationEnabled ||
        _isProgrammableVibrationSettingsEnabled ||
        _isStartVibrationEnabled
    );
};

const isCommonVibrationEnabled = () => {
    const {setting_supported, common_vibration_switcher} = getFeaturesConfig().programmable_vibrations || {};

    return setting_supported && common_vibration_switcher;
};

const isHolderChargedVibrationEnabled = () => getFeaturesConfig().device_holder_charged_vibration;

const isExtendedHapticProfileVibrationEnabled = () => getFeaturesConfig().extended_haptic_profile_vibration;

const isStartVibrationEnabled = () => getFeaturesConfig().start_charging_vibration;

const isProgrammableVibrationSettingsEnabled = () => getFeaturesConfig().programmable_vibrations?.setting_supported;

const isDeviceAlarmEnabled = () => getFeaturesConfig().device_alarm;

const isParentProtectionMode = () => getFeaturesConfig().device_parent_protection_mode;

const isConnectCareModeEnabled = () => getFeaturesConfig().connect_care_mode;

const isResponsiveDrawModeEnabled = () => getFeaturesConfig().device_responsive_draw_profile_mode;

const isVapeCloudModeEnabled = () => getFeaturesConfig().device_vape_cloud_size_mode;

const isAutoStartEnabled = () => getFeaturesConfig().autostart_feature;

const isFlexPuffEnabled = () => getFeaturesConfig().flex_puff;

const isGesturesStatus = () => getFeaturesConfig().status_gestures;

const isAdvancedDiagnostic = () => getFeaturesConfig().advanced_diagnostic;

const isCountDownMode = () => getFeaturesConfig().countdown_mode;

const isSessionProfilingEnabled = () => getFeaturesConfig().session_profiling;

const isIdlePingEnabled = () => getFeaturesConfig().idle_ping;

const getFeaturesConfig = () => iotDeviceConfig.getManagementFeaturesConfig() || {};

export default {
    isAemFlexBatteryEnabled,
    isAemPauseModeEnabled,
    isCountDownMode,
    isGesturesStatus,
    isAutoStartEnabled,
    isFlexPuffEnabled,
    isChargingWhileCleaningNeeded,
    isCleaningEnabled,
    isCommonVibrationEnabled,
    isDeviceAlarmEnabled,
    isDeviceLedModeEnabled,
    isLedModeEnabled,
    isDeviceResetEnabled,
    isConnectCareModeEnabled,
    isExtendedHapticProfileVibrationEnabled,
    isStartVibrationEnabled,
    isHolderChargedVibrationEnabled,
    isHolderLedModeEnabled,
    isParentProtectionMode,
    isProgrammableVibrationSettingsEnabled,
    isResponsiveDrawModeEnabled,
    isVapeCloudModeEnabled,
    isVibrationEnabled,
    isSessionProfilingEnabled,
    isAdvancedDiagnostic,
    isExtendedHolderLedModeEnabled,
    isExtendedDeviceLedModeEnabled,
    isExtendedLedModeEnabled,
    isIdlePingEnabled,
};
